import Vue from "vue";

Vue.component("favorite-notification", {
	props: ["notificationId", "userFilter", "documentSymbol"],
	data() {
		return {
			checkbox: []
		};
	},
	computed: {
		isFavorite() {
			return this.checkbox && this.checkbox.length > 0 ? true : false;
		},
		label() {
			return !this.isFavorite ? window.labels.favoriteAdd : window.labels.favoriteRemove;
		},
		iconPack() {
			return !this.isFavorite ? "far" : "fa";
		},
		iconType() {
			return this.isFavorite ? "is-danger" : "is-dark";
		}
	},
	methods: {
		getIsFavorite: function () {
			this.$services.userNotifications.isFavorite({
					notificationId: this.notificationId
				})
				.then((data) => {
					this.checkbox = [];
					if (data.id > 0) {
						this.checkbox.push("Favorite");
					}
				});
		},
		saveFavorite: function (value) {
			let viewModel = {
				notificationId: this.notificationId,
				isFavorite: value
			}			
			this.$services.userNotifications.addToFavorite(viewModel)
				.then((response) => {
					if (response.status === 400) {
						this.viewModel.errors = response.data.errors;
					} else {
						if (this.userFilter && this.userFilter.filterType == 4 || response.data.isRelatedNotifications) {
							this.$emit("refresh-list");						
						}
					}
				});
		},
		addToFavorite: function (value) {
			let isFavorite = value && value.length > 0;
			this.$buefy.dialog.confirm({
				title: window.labels.favoriteMessage,
				message: this.documentSymbol + ", " + (isFavorite ? window.labels.favoriteAdd : window.labels.favoriteRemove),
				cancelText: window.labels.no,
				confirmText: window.labels.yes,
				type: 'is-success',
				onConfirm: () => {
					this.saveFavorite(isFavorite);
				},
				onCancel: () => {
					this.checkbox = isFavorite ? [] : ['Favorite'];
				}
			});
		},
	},
	mounted() {
		this.getIsFavorite();
	},
	template: `
		<div class="favorite-notification">
	        <b-tooltip :label="label" type="is-primary is-light" position="is-bottom" size="is-small" multilined>
				<b-checkbox-button v-model="checkbox" @input="addToFavorite" native-value="Favorite" type="is-text"><b-icon size="is-medium" :pack="iconPack" icon="star" :type="iconType"></b-icon> </b-checkbox-button>
	        </b-tooltip>
		</div>
	`
});